import getConfig from 'next/config';

import { ISravniRating } from '../interfaces/ratings';
import client from '../utils/client';

export interface IRatingsParams {
  OrganizationType: string;
  ReviewTag: string;
}

export const getSummaryRatings = async (params: IRatingsParams): Promise<ISravniRating[]> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/ratings`;
  const { data } = await client.get<ISravniRating[]>(url, { params });

  return data;
};
